import "./styles/globals.css"
import { QueryClientProvider } from "@tanstack/react-query"
import { createRouter, RouterProvider } from "@tanstack/react-router"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { routeTree } from "./app/routeTree.gen"
import { RouterErrorScreen } from "./shared/components/RouterErrorScreen"
import { queryClient } from "./shared/lib/queryClient"
import { hydrateQueryCache, startQueryPersistence } from "./shared/lib/queryPersist"

// Restore the persisted offline cache before the router prefetches, then keep it in sync.
hydrateQueryCache(queryClient)
startQueryPersistence(queryClient)

const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: "intent",
  defaultErrorComponent: RouterErrorScreen,
  scrollRestoration: true,
})

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router
  }
}

const rootElement = document.getElementById("root")
if (!rootElement) throw new Error("Root element #root not found")

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
)

// Register the SW only in PWA builds (__PWA__ absent in dev).
if (typeof __PWA__ !== "undefined" && __PWA__ && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {})
  })
}
